export const translations = {
    en: {
        "devices.all": "All",
        "select.model": "Select a model...",

        devicegroup: "Device Group",
        networksync: "Network",
        waypoint: "Waypoint",
        AssetGroup: "Container Group",
        deviceconfig: "Device Config",
        asset: "Container",
        devicesunloads: "Device Unloads",
        recovery: "Recovery",
        zone: "Zone",
        device: "Device",
        devicentp: "NTP",
        device_ship: "Device Ship",
        shipping: "Shipping",
        island: "Island",
        devicesensors: "Device Sensors",
        routestatic: "Static Route",
        routedynamic: "Dynamic Route",
        firmware: "Firmware",
        deviceserver: "Device Server",
        devicemqtt: "MQTT",
        programming: "Programming",
        user: "User",
        assetgroup: "Container Group",
        networkconfig: "Network",
        pga460: "PGA",
    },
    es: {
        "devices.all": "Todos",
        "select.model": "Selecciona un modelo...",

        devicegroup: "Grupo de Dispositivos",
        networksync: "Sincronización de Red",
        waypoint: "Punto de Ruta",
        AssetGroup: "Grupo de Contenedores",
        deviceconfig: "Configuración de Dispositivo",
        devicesunloads: "Descargas",
        recovery: "Recuperación",
        zone: "Zona",
        device: "Dispositivo",
        devicentp: "NTP",
        device_ship: "Envío de Dispositivo",
        shipping: "Envío",
        island: "Isla",
        devicesensors: "Sensores",
        routestatic: "Ruta Estática",
        asset: "Contenedor",
        routedynamic: "Ruta Dinámica",
        firmware: "Firmware",
        deviceserver: "Servidor de Dispositivo",
        devicemqtt: "MQTT",
        programming: "Programación",
        user: "Usuario",
        assetgroup: "Grupo de Contenedores",
        networkconfig: "Redes",
        pga460: "PGA",
    },
};

export default translations;
